import { render, staticRenderFns } from "./LogonComponent.vue?vue&type=template&id=fb5421ec&scoped=true&"
import script from "./LogonComponent.vue?vue&type=script&lang=ts&"
export * from "./LogonComponent.vue?vue&type=script&lang=ts&"
import style0 from "./LogonComponent.vue?vue&type=style&index=0&id=fb5421ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5421ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer,VFlex,VLayout})
